function n(r, t, i) {
  this.type = r, this.tag = t, this.attrs = null, this.map = null, this.nesting = i, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
n.prototype.attrIndex = function(t) {
  if (!this.attrs)
    return -1;
  const i = this.attrs;
  for (let s = 0, e = i.length; s < e; s++)
    if (i[s][0] === t)
      return s;
  return -1;
};
n.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
n.prototype.attrSet = function(t, i) {
  const s = this.attrIndex(t), e = [t, i];
  s < 0 ? this.attrPush(e) : this.attrs[s] = e;
};
n.prototype.attrGet = function(t) {
  const i = this.attrIndex(t);
  let s = null;
  return i >= 0 && (s = this.attrs[i][1]), s;
};
n.prototype.attrJoin = function(t, i) {
  const s = this.attrIndex(t);
  s < 0 ? this.attrPush([t, i]) : this.attrs[s][1] = this.attrs[s][1] + " " + i;
};
export {
  n as default
};
